import { useSelector } from 'react-redux'
import props from '../../../../../../../redux/props'
import { ConceptValues } from '../../../../../../../types/Survey/Analysis/Concept'
import Modules from './Modules'
import Areas from './Areas'
import Headline from '../../../../../../UI/Headline/Headline'
import OptimizationModeSelection from '../OptimizationModeSelection/OptimizationModeSelection'

type Props = {
  values: ConceptValues
  updateValue: (key: string) => (value: any) => void
}

const SurveyResults: React.FC<Props> = ({ values, updateValue }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="mt-5">
      <Headline text={t.survey.analysis.calculation.values.unitSurveyResults.headline} />
      <OptimizationModeSelection value={values.optimizationMode} onChange={updateValue('optimizationMode')} />
      <div className="font-light text-md mt-5">{t.survey.analysis.calculation.values.unitSurveyResultsAreas.headline}</div>
      <Areas values={values} />
      <div className="font-light text-md mt-5">{t.survey.analysis.calculation.values.unitSurveyResultsModules.headline}</div>
      <Modules values={values} />
    </div>
  )
}

export default SurveyResults
